export enum LogLevel {
  off = 0,
  error = 1,
  warn = 2,
  log = 3,
  info = 4,
  debug = 5,
  verbose = 6,
}

export class CapicheLoggerCore {
  private level: LogLevel = LogLevel.off;

  constructor(
    private prefix: string,
    enabledOrLevel: boolean | LogLevel = true,
    private structured: boolean = false, // default off for browser/Angular
  ) {
    this.setLevel(enabledOrLevel);
    if (this.level >= LogLevel.error) {
      console.debug('ts-logger-core:', this.prefix, 'level', LogLevel[this.level], 'structured', this.structured);
    }
  }

  setLevel(enabledOrLevel: boolean | LogLevel) {
    if (typeof enabledOrLevel === 'boolean') {
      this.level = enabledOrLevel ? LogLevel.log : LogLevel.off;
    } else {
      this.level = enabledOrLevel ?? LogLevel.off;
    }
  }

  getLevelName(): keyof typeof LogLevel {
    return LogLevel[this.level] as keyof typeof LogLevel;
  }

  // prettier-ignore
  verbose(...args: unknown[]) { if (this.level >= LogLevel.verbose) console.debug(this.prefix, ...args); }
  // prettier-ignore
  debug(...args: unknown[]) { if (this.level >= LogLevel.debug) console.debug(this.prefix, ...args); }
  // prettier-ignore
  info(...args: unknown[]) { if (this.level >= LogLevel.info) console.info(this.prefix, ...args); }
  // prettier-ignore
  log(...args: unknown[]) { if (this.level >= LogLevel.log) console.log(this.prefix, ...args); }
  // prettier-ignore
  warn(...args: unknown[]) { if (this.level >= LogLevel.warn) console.warn(this.prefix, ...args); }

  error(...args: unknown[]) {
    if (this.level >= LogLevel.error) {
      if (this.structured) {
        const entry = {
          severity: 'ERROR',
          prefix: this.prefix,
          timestamp: new Date().toISOString(),
          message: args,
        };
        console.error(JSON.stringify(entry));
      } else {
        console.error(this.prefix, ...args);
      }
    }
  }
}
